import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { UrlBuilderService } from '@feature/common';
import { RuleSet } from 'ngx-angular-query-builder';
import {ListType} from "@common/enums/list-type";

@Injectable()
export class ListTypeUserDataFilterService {

  constructor(
    private readonly http: HttpClient,
    private readonly urlBuilder: UrlBuilderService)
  {
  }

  saveFilter(listTypeId: ListType, filter: RuleSet): Observable<any> {
    const url = this.urlBuilder.getUrl('userlistfilter');
    return this.http.post(url, { ListTypeId: listTypeId, Filter: filter });
  }

  loadFilter(listTypeId: ListType): Observable<RuleSet> {
    const url = this.urlBuilder.getUrl('userlistfilter');
    const params = new HttpParams().set('listTypeId', listTypeId);
    return this.http.get<RuleSet>(url, { params: params });
  }

}
